import { createContext, useContext, useState } from "react";
import { useHospitalData } from "./HospitalDataProvider";
import { useWeekIndex } from "./WeekIndexProvider";

interface ModalContextType {
	show: boolean;
	setShow: any;
	nurseId: number;
	setNurseId: any;
	shiftNo: number;
	setshiftNo: any;
	sethoveredShiftNo: any;
	hoveredShiftNo: number;
	onClose: any;
	onDelete: any;
	setDayNo: any;
	dayNo: any;
}

const ModalContext = createContext<ModalContextType>({
	show: false,
	setShow: (show: boolean) => {},
	nurseId: -1,
	setNurseId: (nurseId: number) => {},
	shiftNo: -1,
	setshiftNo: (shiftNo: number) => {},
	onClose: () => {},
	onDelete: () => {},
	setDayNo: (dayNo: number) => {},
	hoveredShiftNo: 1,
	dayNo: -1,
	sethoveredShiftNo: (shiftNo: number) => {},
});

export const useModalContext = () => useContext(ModalContext);

export const ModalProvider = ({ children }: any) => {
	const { removeNurseFromSpecificDate }: any = useHospitalData();

	const [show, setShow] = useState(false);
	const [nurseId, setNurseId] = useState(-1);
	const [shiftNo, setshiftNo] = useState(-1);
	const [hoveredShiftNo, sethoveredShiftNo] = useState(1);
	const [dayNo, setDayNo] = useState(-1);
	const { weekIndex, setWeekIndex } = useWeekIndex();

	const onClose = () => {
		setShow(false);
		setDayNo(-1);
		setshiftNo(-1);
	};

	const onDelete = () => {
		removeNurseFromSpecificDate(weekIndex, dayNo, shiftNo, nurseId);
		setShow(false);
		setDayNo(-1);
		setshiftNo(-1);
	};

	return (
		<ModalContext.Provider
			value={{
				show,
				setShow,
				nurseId,
				setNurseId,
				setDayNo,
				dayNo,
				shiftNo,
				setshiftNo,
				onClose,
				onDelete,
				hoveredShiftNo,
				sethoveredShiftNo,
			}}
		>
			{children}
		</ModalContext.Provider>
	);
};
